import __request__ from "routing/request";
export function update(body, requestOptions) {
  return __request__("PUT", "/system/indices/index_set_defaults", body, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
